import { useContext, useCallback } from 'react';
import { LOW_RESULTS_THRESHOLD, LOW_RESULTS_COUNT } from '~/constants';
import InventoryContext from '~/contexts/InventoryContext';
import { InventoryResponse, InventoryRequest } from '~/services/contracts';
import fetchLowInventory from '~/services/fetchLowInventory';
import generateErrorLogger, { toError } from '~/utilities/errorHandlers';

export default function useGetLowInventory() {
  const { setSimilarVehicles } = useContext(InventoryContext);

  return useCallback(
    async (
      request: InventoryRequest,
      inventoryData: InventoryResponse,
      controller
    ) => {
      try {
        const {
          inventory: {
            pagination: { totalMatchedInventory, totalMatchedPages },
            vehicles: inventoryVehicles
          }
        } = inventoryData;
        const lowInventory =
          totalMatchedPages === 1 &&
          inventoryVehicles.length < LOW_RESULTS_THRESHOLD;
        const noInventory = !totalMatchedInventory;

        if (!lowInventory && !noInventory) return;

        if (lowInventory) {
          request.pagination = {
            page: 1,
            pageSize: totalMatchedInventory + LOW_RESULTS_COUNT
          };
        }

        const {
          data: { inventory, searchRequestId }
        } = await fetchLowInventory(request, controller);

        const { vehicles: allSimilarVehicles } = inventory;
        const existingVehicleIds = inventoryVehicles.map(v => v.vehicleId);
        const deduplicatedVehicles = allSimilarVehicles
          .filter(v => !existingVehicleIds.includes(v.vehicleId))
          .slice(0, LOW_RESULTS_COUNT);
        setSimilarVehicles({
          searchRequestId,
          vehicles: deduplicatedVehicles
        });
      } catch (error) {
        generateErrorLogger('Low Inventory')(toError(error));
      }
    },
    [setSimilarVehicles]
  );
}
